/* builder_rules.js — Rules adapter for modular builder (UNIVERSAL)
 * 
 * This file works with ANY product by reading from product metafields.
 * No product-specific code - all configuration comes from metafields.
 * 
 * CONTRACT:
 * - No-color mode: rules.core.heights[] and rules.core.depths[] provide selector values
 * - Color mode (future): rules.colors[] with per-color heights/depths
 * 
 * METAFIELD: custom.builder_rules (JSON)
 * Example no-color:
 *   { 
 *     "core": { 
 *       "heights": ["72","84","90","108"] or [{"value":"72","label":"72\""},...],
 *       "depths": ["24","30","43"] or [{"value":"24","label":"24\""},...]
 *     }
 *   }
 * 
 * SUPPORTS:
 * - Simple arrays: ["72","84"]
 * - Labeled objects: [{"value":"72","label":"72\" | 183cm"}]
 * - Mixed formats in same array
 */
(function () {
  class BuilderRules {
    constructor(rulesJSON) {
      // 兼容两种写法：
      // A) 旧：{ colors:[{handle,heights,depths}], defaultColor, notes }
      // B) 新：{ core:{heights:[], depths:[]}, notes, accessories:{...} }
      this.rules = rulesJSON || {};
      this.colorsByKey = {};
      (this.rules.colors || []).forEach(c => {
        const key = (c.handle || c.label || '').toLowerCase();
        this.colorsByKey[key] = c;
      });
    }

    // —— 无颜色模式：直接取 core.heights / core.depths
    // Supports both simple arrays ["72","84"] and objects [{value:"72",label:"72\""}]
    coreHeights() {
      if (this.rules.core && Array.isArray(this.rules.core.heights)) {
        return this.rules.core.heights;
      }
      // 兼容旧色彩模式：取默认色的高度
      const def = this.defaultColor();
      return def ? (this.heightsForColor(def) || []) : [];
    }
    coreDepths() {
      if (this.rules.core && Array.isArray(this.rules.core.depths)) {
        return this.rules.core.depths;
      }
      const def = this.defaultColor();
      return def ? (this.depthsForColor(def) || []) : [];
    }
    
    // Helper to get value from either string or object format
    getValue(item) {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') return item.value || item;
      return String(item);
    }
    
    // Helper to get label from object format, or fall back to value
    getLabel(item) {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') return item.label || item.value || item;
      return String(item);
    }

    // —— 以下是旧色彩模式保留（如果你以后又想加色）
    allColors() { return this.rules.colors || []; }
    colorAvailable(handleOrLabel) {
      const key = String(handleOrLabel || '').toLowerCase();
      const c = this.colorsByKey[key] || {};
      return c.available !== false;
    }
    heightsForColor(h) {
      const key = String(h || '').toLowerCase();
      return (this.colorsByKey[key]?.heights) || [];
    }
    depthsForColor(h) {
      const key = String(h || '').toLowerCase();
      return (this.colorsByKey[key]?.depths) || [];
    }
    defaultColor() { return this.rules.defaultColor || (this.rules.colors && this.rules.colors[0]?.handle); }
    note(k) { return (this.rules.notes || {})[k] || null; }

    swatchColor(handleOrLabel) {
      const key = String(handleOrLabel || '').toLowerCase();
      const c = this.colorsByKey[key] || {};
      return c.swatch || c.handle || c.label || '#333';
    }
  }
  window.BuilderRules = BuilderRules;
})();
